const Constants = {
    CIRCLE_TYPES: 7
}

export {Constants}
